import { cn } from '~/styles/extended-theme';

interface RichTextHtmlViewerProps {
  rawHtml: string;
  className?: string;
}

export function RichTextHtmlViewer({ rawHtml, className }: RichTextHtmlViewerProps) {
  return (
    <div
      className={cn('ql-editor ql-viewer', className)}
      dangerouslySetInnerHTML={{ __html: rawHtml }}
    />
  );
}
